import React from 'react';
import BasicAnt from './images/BasicAnt.png';
import Level from './images/LevelStat.png';
import Star from './images/Icon_Star.png';

function InventoryBasicAnt({ antInfo, changeActiveComponent }) {
    const { mint, level, experience, type, name, remainPotions, metadata } = antInfo;
    const progressPercentage = (remainPotions / (level + 1)) * 100;
    const formatMint = (mint) => {
        if (!mint) return '';
        return `${mint.substring(0, 10)}...${mint.substring(mint.length - 10)}`;
    };

    const copyToClipboard = (text) => {
        if (!text) return;
        navigator.clipboard.writeText(text).then(() => {
            alert('Address copied to clipboard!'); // Provide user feedback
        }, (err) => {
            console.error('Failed to copy address', err);
        });
    };

    return (
        <section id="inventory-purse">
                <div className="inventory-container-right">
                    <div className="active-item-header-content" id="ant-header">
                    <div className="inventory-item-active item-basic antonright"> <img src={metadata?.image || BasicAnt} alt={name} /></div>
                        <div className="active-item-header">
                        <h2>Worker ANT</h2>
                        <p>Basic ant</p>
                        <p id="w-address" style={{ cursor: 'pointer' }} onClick={() => copyToClipboard(mint)}>{formatMint(mint)}</p></div>
                        <div className="descrition"><p>Worker ANTS are hard workers. They will earn additional rewards from the workforce.</p></div>
                        </div>
                        <div className="level-bar-container">
                  <div className="level-bar">
      <div className="level-indicator">
      LVL: <span className="bold-text">{level}</span>
      </div>
      <div className="exp-bar-container">
        <div 
          className="exp-bar" 
          style={{ width: `${progressPercentage}%` }}
        ></div>
      </div>
      <div className="exp-info">
        EXP:<span className="bold-text"> {remainPotions}/{level+1}</span>
      </div>
    </div>
    </div>
                        <div className="active-item-buttons-container">
                       {/* <button className="active-item-button-upper" id="right3">LIST FOR SALE</button> */}
                        <button className="active-item-button-lower" id="basic-ant-button" onClick={() => changeActiveComponent('shop')}>BUY ANOTHER ONE</button>
                        </div>
                </div>
                </section>
      );
    }
    
    export default InventoryBasicAnt;